import { AdminMessage } from "@components/admin/admin-helpers"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { EventBadges } from "@components/film/EventBadges"
import { LargeCard } from "@components/patterns/LargeCard"
import { chipStyles } from "@components/ui/Chip"
import { useFilmBadges } from "@features/program/useFilmBadges"
import { TrackingHelpers } from "@features/tracking/tracking-helpers"
import { splitFilmTitle } from "@utils/split-film-title"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"

export const meta: BlockMeta = {
  title: "Large Film Card",
  description: "A large film card, for heroing a certain film.",
  category: "embed",
  tags: ["#featured"],
  flags: {
    fullWidth: true,
    marginRule: "featured-card",
  },
}

export default defineBlock("hero/large-film-card", (props) => {
  if (!props.film) {
    if (env.admin) {
      return <AdminMessage>No film selected</AdminMessage>
    }
    return null
  }

  const { film, theme } = props

  const badges = useFilmBadges({ film })

  const tags = [
    <EditableText
      store="extraBadge"
      placeholder="Optional extra badge"
      plainText
      as="span"
      className={chipStyles().base()}
    />,
    <EditableText
      store="extraBadge2"
      placeholder="Optional extra badge"
      plainText
      as="span"
      className={chipStyles().base()}
    />,
  ]

  if (badges.length > 0) {
    tags.unshift(<EventBadges film={film} />)
  }

  const { filmTitle, filmTag } = splitFilmTitle(film?.title ?? "")

  return (
    <Link
      href={film.uri}
      className="block w-grid mx-auto"
      data-mixpanel-block="Large Film Card"
      data-mixpanel-heading={film.title}
      {...(props.film && TrackingHelpers.filmAttrs(props.film))}
      as={env.admin ? "div" : undefined}
    >
      <LargeCard
        theme={theme!}
        title={
          <div>
            {filmTag ? <div>{filmTag}:</div> : null}
            {filmTitle}
          </div>
        }
        description={<EditableText store="description" defaultValue={film.descriptions?.short} />}
        media={
          <ResponsiveImage {...film.media?.thumb} objectFit="cover" className="size-full md:absolute md:inset-0" />
        }
        layout="auto"
        infoWidth="md"
        height="lg"
        tags={tags}
      />
    </Link>
  )
})
